import { render } from "./EventList.vue?vue&type=template&id=ca9a56ca&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=ca9a56ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ca9a56ca"

export default script